const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the content search component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 * @argument {Categories} Categories the resource defined to manage Categories
 */
app.directive('contentSearch', ['Application', 'Videos', 'Files', 'Articles', 'Tracks', 'ScormContent', 'ImportedContent', 'Assessments', 'Workshops', 'Journeys', '$q', function (Application, Videos, Files, Articles, Tracks, ScormContent, ImportedContent, Assessments, Workshops, Journeys, $q) {
  return {
    restrict: 'E',
    scope: {
      startItems: '=',
      onChange: '&',
      selectionLimit: '@',
      typeRestrictions: '=?',
      includeWorkshops: '@?',
      clear: '=',
      selectedContent: '=',
    },
    template: require('../../templates/directives/content-searchbar.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queries = [];
      self.updateQuery = function () {
        $scope.onChange({items: self.queries});
      };
      self.given = {
        find: function (type, id) {
          if (!type || !id) {
            return false;
          }
          switch (type) {
            case 'article':
              return Articles.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            case 'video':
              return Videos.get({subresource: id, fields: 'title,type,tags'}).$promise;
              break;
            case 'file':
              return Files.get({subresource: id, fields: 'title,type,tags'}).$promise;
              break;
            case 'track':
              return Tracks.get({subresource: id, fields: 'name,tags,type'}).$promise;
              break;
            case 'scorm':
              return ScormContent.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            case 'imported_content':
              return ImportedContent.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            case 'assessment':
              return Assessments.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            case 'workshop':
              return Workshops.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            case 'journey':
              return Journeys.get({subresource: id, fields: 'title,tags,type'}).$promise;
              break;
            default:
              break;
          }
        },
        parse: function () {
          if (!$scope.startItems || !$scope.startItems.length) {
            return;
          }
          var promises = [];
          for (var i = 0; i < $scope.startItems.length; i++) {
            var promise = this.find($scope.startItems[i].type, $scope.startItems[i].id);
            if (!promise) {
              continue;
            }
            promises.push(promise);
          }
          $q.all(promises).then(function(items) {
            for (var i = 0; i < items.length; i++) {
              self.queries.push({
                name: items[i].title || items[i].name,
                text: items[i].title || items[i].name,
                _id: items[i]._id,
                type: items[i].type
              });
            }
          });
        }
      };
      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag._id || !$tag.type || !$tag.name) {
            return false;
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              self.queries.splice(0, 1);
            }
          }
          return true;
        },
        addedTag: function ($tag, outside) {
          self.updateQuery();
        },
        removedTag: function ($tag) {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.getOptions = function (input) {
        if (!initClosed) {
          initClosed++;
          initWatch();
        }
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var placeholders = {
          article: {name: 'Articles', text: 'Articles', _id: 'articles', placeholder: true},
          video: {name: 'Videos', text: 'Videos', _id: 'videos', placeholder: true},
          file: {name: 'Files', text: 'Files', _id: 'files', placeholder: true},
          track: {name: 'Tracks', text: 'Tracks', _id: 'tracks', placeholder: true},
          scorm: {name: 'Scorm', text: 'Scorm', _id: 'scorm', placeholder: true},
          imported_content: {name: 'ImportedContent', text: 'Imported Content', _id: 'imported_content', placeholder: true},
          assessment: {name: 'Assessment', text: 'Assessment', _id: 'assessment', placeholder: true},
          workshop: {name: 'Workshop', text: 'Workshop', _id: 'workshop', placeholder: true},
          journey: {name: 'Journey', text: 'Journey', _id: 'journey', placeholder: true}
        };
        var addedItems = {
          articles: false,
          videos: false,
          files: false,
          tracks: false,
          scorm: false,
          imported_content: false,
          assessment: false,
          workshop: false,
          journey: false,
        };

        
        var contentQuery = {
          subresource: '',
          page: 1,
          per_page: 10,
          fields: 'title,tags,type',
          $or: '10,title,$regex,2,' + input + ',i,tags,$regex,2,' + input + ',i' 
        };
        var trackQuery = {
          subresource: '',
          page: 1,
          per_page: 10,
          fields: 'name,tags',
          $or: '10,name,$regex,2,' + input + ',i,tags,$regex,2,' + input + ',i'
        };
        const journeyQuery = {
          subresource: '',
          page: 0,
          perPage: 10,
          query: {term: input}
        };
        
        const notIncludedInSearch = $scope.selectedContent && $scope.selectedContent.length && `$nin,${$scope.selectedContent.length},${$scope.selectedContent.join(',')}` || '';
        if (notIncludedInSearch && notIncludedInSearch.length) {
          contentQuery._id = notIncludedInSearch;
        }

        const articlePromise = Articles.find(contentQuery).$promise;
        const videoPromise = Videos.find(contentQuery).$promise;
        const filePromise = Files.find(contentQuery).$promise;
        const trackPromise = Tracks.find(trackQuery).$promise;
        const scormPromise = ScormContent.find(contentQuery).$promise;
        const importedContentPromise = ImportedContent.find(contentQuery).$promise;
        const assessmentPromise = Assessments.find(contentQuery).$promise;
        const contentPromises = [articlePromise, videoPromise, filePromise, trackPromise, scormPromise, importedContentPromise, assessmentPromise];
        if (Application.features.journeys()) {
          contentPromises.push(Journeys.find(journeyQuery).$promise)
        }
        if ($scope.includeWorkshops) {
          var workshopsPromise = Workshops.find(contentQuery).$promise;
          contentPromises.push(workshopsPromise);
        }

        $q.all(contentPromises)
        .then(function (results) {
          var directory = {
            0: 'article',
            1: 'video',
            2: 'file',
            3: 'track',
            4: 'scorm',
            5: 'imported_content',
            6: 'assessment',
          };
          if (Application.features.journeys()) {
            directory[7] = 'journey';
          }
          if ($scope.includeWorkshops) {
            if (directory[7]) {
              directory[8] = 'workshop';
            } else {
              directory[7] = 'workshop';
            }
          }

          var restricted = {};
          if ($scope.typeRestrictions && $scope.typeRestrictions.length) {
            $scope.typeRestrictions.forEach(function(item) {
              restricted[item] = true;
            });
          }

          var items = [];
          for (var i = 0; i < results.length; i++) {
            if (!results[i] || !results[i].length) {
              continue;
            }
            var type = directory[i];
            if (restricted[type]) {
              continue;
            }
            if (!addedItems[type]) {
              items.push(placeholders[type]);
              addedItems[type] = true;
            }
            for (var j = 0; j < results[i].length; j++) {
              items.push({
                name: results[i][j].title || results[i][j].name,
                text: results[i][j].title || results[i][j].name,
                _id: results[i][j]._id,
                type: type
              });
            }
          }
          deferred.resolve(items);
        }).catch(function (error) {
          // error messaging
        });

        return deferred.promise;
      };

      var initClosed = 0;
      var initWatch = $scope.$watch('startItems', function(newVal, oldVal) {
        if (newVal) {
          self.given.parse();
          initWatch();
        }
      });
      $scope.$watch('clear', function(newVal, oldVal) {
        if (newVal && !oldVal) {
          self.tagInput.clear(true);
          $scope.clear = false;
        }
      });
    }],
    controllerAs: 'search'
  };
}]);
